import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import Modal from 'react-bootstrap/Modal';
import Header from "./header";
import SideNav from "./sidenav";
import Action5 from "../assets/images/Action-5.png";


const ReportManagement = () => {

 
    return (
        <div>
            <Header />
            <SideNav />

            <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4>Reports Management</h4>
                        </div>
                    </div>
                    <div class="ReportBox">
                            <ul>
                                <li>
                                    <Link to="/report-order">
                                        <span><i class="fa fa-cubes" aria-hidden="true"></i></span>
                                        <figcaption>
                                            <h3>Orders  Reports</h3>
                                            <p></p>
                                        </figcaption>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/report-product">
                                        <span><i class="fa fa-file-text" aria-hidden="true"></i></span>
                                        <figcaption>
                                            <h3>Products  Reports</h3>
                                            <p></p>
                                        </figcaption>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/report-admin">
                                        <span><i class="fa fa-money" aria-hidden="true"></i></span>
                                        <figcaption>
                                            <h3>Admin payment Report</h3>
                                            <p></p>
                                        </figcaption>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/report-transaction">
                                        <span><i class="fa fa-exchange" aria-hidden="true"></i></span>
                                        <figcaption>
                                            <h3>Transaction  Reports</h3>
                                            <p></p>
                                        </figcaption>
                                    </Link>
                                </li>
                            </ul>
                        </div>
               
                </div>
            </div>
        </div>
    );
}
export default ReportManagement